export default __webpack_public_path__ + "/dist/images/Andrea.4d06316350df37d46d13a3058e31a6b6.png";